import { Divider } from '@tribeplatform/react-ui-kit/Divider'

import { BC } from '../../types/index.js'
import { DividerProps } from './types.js'

export const DividerBlock: BC<DividerProps> = Divider
